import {
  IApplicationRelationshipLevels,
  ICarrierRelationshipTypes,
  Maybe,
} from 'types/graphqlTypes'
import { ICarrierRelationshipInfoFragment } from '../../../Carrier/graphql/CarrierRelationshipInfoFragment'

export interface IGroupedCarrierRelationships {
  primaryCarrierManager: Maybe<ICarrierRelationshipInfoFragment>
  secondaryCarrierManagers?: Maybe<ICarrierRelationshipInfoFragment[]>
  primaryCeRep: Maybe<ICarrierRelationshipInfoFragment>
  secondaryCeRep: Maybe<ICarrierRelationshipInfoFragment>
  primarySalesRep: Maybe<ICarrierRelationshipInfoFragment>
  secondarySalesReps?: Maybe<ICarrierRelationshipInfoFragment[]>
}
/**
 * @description get carrier relationships grouped by their type and level
 */
export const groupCarrierRelationships = (
  carrierRelationships?: ICarrierRelationshipInfoFragment[]
): IGroupedCarrierRelationships => {
  return {
    primaryCarrierManager: carrierRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.primary &&
        cr.relationshipType === ICarrierRelationshipTypes.carrier_manager
    ),
    secondaryCarrierManagers: carrierRelationships?.filter(
      cr =>
        cr.relationshipType === ICarrierRelationshipTypes.carrier_manager &&
        cr.relationshipLevel === IApplicationRelationshipLevels.secondary
    ),
    primaryCeRep: carrierRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.primary &&
        cr.relationshipType === ICarrierRelationshipTypes.carrier_experience_representative
    ),
    secondaryCeRep: carrierRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.secondary &&
        cr.relationshipType === ICarrierRelationshipTypes.carrier_experience_representative
    ),
    primarySalesRep: carrierRelationships?.find(
      cr =>
        cr.relationshipLevel === IApplicationRelationshipLevels.primary &&
        cr.relationshipType === ICarrierRelationshipTypes.carrier_sales_representative
    ),
    secondarySalesReps: carrierRelationships?.filter(
      cr =>
        cr.relationshipType === ICarrierRelationshipTypes.carrier_sales_representative &&
        cr.relationshipLevel === IApplicationRelationshipLevels.secondary
    ),
  }
}
